import { OptionType } from './AttributesMap.types';

export const isCompositeOrStatistic = (attribute: OptionType) =>
  attribute.signalType === 'composite' || attribute.signalType === 'statistic';
